'use strict';

import { getCookieByName, getCookie } from 'shared/js/util/cookies-operation';
import toBoolean from 'shared/js/util/toBoolean';

export const isFunctionalAllowed = () => {
    // Naming originates from the earlier implementation,
    // ex., @see SFCC-394
    let cookie = getCookie('set_functional_cookies') || getCookie('OptanonConsent', 'C0003');
    return toBoolean(cookie);
};

export const isRequiredCookieAllowed = () => {
    // Naming originates from the earlier implementation,
    // ex., @see SFCC-1124
    let cookie = getCookieByName('set_necessary_cookies');
    return toBoolean(cookie);
};

export default {
    isFunctionalAllowed,
    isRequiredCookieAllowed
};
